import { AbstractScatterVisualization } from '../visualization.abstract.scatter.component';
export class CCAGraph extends AbstractScatterVisualization {
}
